/* ---- Search form (history page) ---- */

import { ICONS } from '../icons';

export interface SearchFormValues {
  fenceName: string;
  date: string;
  type: string;
}

export function renderSearchForm(onSearch: (values: SearchFormValues) => void): HTMLElement {
  const el = document.createElement('div');
  el.className = 'sa';

  el.innerHTML = `
    <div style="margin-bottom:10px">
      <label class="fl">ジオフェンス名称</label>
      <input class="tx" id="search-fence" type="text" placeholder="例: 東京駅八重洲口">
    </div>
    <div class="rw">
      <div>
        <label class="fl">日時</label>
        <input class="di" id="search-date" type="date">
      </div>
      <div>
        <label class="fl">イベント種別</label>
        <div class="sw">
          <select id="search-type">
            <option value="">すべて</option>
            <option value="zone_entry">入場</option>
            <option value="zone_stay">滞在</option>
            <option value="zone_exit">退場</option>
          </select>
          <div class="cv">${ICONS.chevronDown}</div>
        </div>
      </div>
    </div>
    <button class="sb2" id="search-btn">
      ${ICONS.search} 検索
    </button>
  `;

  const btn = el.querySelector('#search-btn')!;
  btn.addEventListener('click', () => {
    const fenceName = (el.querySelector('#search-fence') as HTMLInputElement).value;
    const date = (el.querySelector('#search-date') as HTMLInputElement).value;
    const typeSelect = el.querySelector('#search-type') as HTMLSelectElement;
    const type = typeSelect.value;

    // Update select styling
    typeSelect.className = type ? 'hv' : '';

    onSearch({ fenceName, date, type });
  });

  // Update select class on change
  const typeSelect = el.querySelector('#search-type') as HTMLSelectElement;
  typeSelect.addEventListener('change', () => {
    typeSelect.className = typeSelect.value ? 'hv' : '';
  });

  return el;
}
